import React from 'react';

import SchemaCatalogShell from './SchemaCatalogShell';

/**
 * Component types — the registry of CMS component kinds. Each row
 * carries a `schema_json` blob describing the props the component
 * accepts (field names, types, required flags). The schema drives
 * per-tenant component config validation + the CMS property panel.
 *
 * R5: raw Monaco editor for `schema_json` only. A structured 2-pane
 * form + preview (per Designer B spec) lands in a later round — the
 * plumbing for it (schema_json column + side drawer) is already here.
 */

const ComponentTypes: React.FC = () => (
  <SchemaCatalogShell
    slug="component-types"
    title="Component types"
    breadcrumbLabel="Component types"
    emptyBody="Component types enumerate the CMS components tenants can instantiate. Each type's schema_json describes its prop surface."
    addCtaLabel="Add first component type"
    schemaHint="Each row's schema_json describes the component's props."
  />
);

export default ComponentTypes;
